import React, { useState, useEffect } from "react";
import Cards from "react-credit-cards";
import MaskInput from "../../../components/MaskInput";
import "react-credit-cards/es/styles-compiled.css";
import Input from "../../../components/Input";
import { Button } from "../../../components/Button";
import { Select } from "../../../components/Select";
import Modal from "./Modal";
import ModalPago from "./ModalPago";
import ModalDomiciliacion from "./ModalDomiciliacion";
import { PRODUCT_TYPES } from "../../../utils/Constants";
import {
  procesarYRegistrarPago,
  notificarPagoIntermediario,
} from "../../../services/PagoService";
import { usePagoAuth } from "../../../context/PagoAuthContext";
import { CONSTANT } from "../../../utils/Constants";
import { getPolicyType } from "../../../utils/AppUtils";

const FormTarjeta = ({
  setModal,
  datosFacturacion,
  setIsLoadingModal,
  balancePoliza,
}) => {
  const { accessToken } = usePagoAuth();
  const [focus, setFocus] = useState("number");
  const [tipoTarjeta, setTipoTarjeta] = useState({ issuer: "", maxLenth: 0 });
  const [montoPagar, setMontoPagar] = useState("");
  const [renderButton, setRenderButton] = useState(false);
  let detalleTarjeta = null;
  const [tarjeta, setTarjeta] = useState({
    number: "",
    expiry: "",
    cvv: "",
    name: "",
  });
  const max = {
    number: 16,
    expiry: 4,
    cvv: 3,
  };

  const selectMontoPago = [
    {
      name: "Selecionar pago",
      value: "",
    },
    {
      name: "Pago mínimo",
      value: "pagoMinimo",
    },
    {
      name: "Pago total",
      value: "pagoTotal",
    },
  ];

  useEffect(() => {
    const ac = new AbortController();
    return () => ac.abort();
  }, [tipoTarjeta.maxLenth]);

  const currencyFormater = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  const onFocus = (e) => {
    setFocus(e.target.name);
  };

  const mostrarModal = (
    titulo,
    mensaje,
    modalType,
    comprobante,
    autorizacion
  ) => {
    const hideModal = () => {
      setModal({ isVisible: false, component: null });

      comprobante && mostrarModalDomiciliacion();
    };

    setModal({
      isVisible: true,
      component: (
        <Modal
          cuerpo={mensaje}
          recibo={comprobante}
          autorizacion={autorizacion}
          onCancel={hideModal}
          titulo={titulo}
          modalType={modalType}
        />
      ),
    });
  };

  const onChange = (e) => {
    if (e.target.name === max[e.target.name]) return;
    setTarjeta({ ...tarjeta, [e.target.name]: e.target.value });
  };

  const obtenerNumeroTarjeta = (tarjetaCredito) => {
    // Validar tipo tarjeta
    if (tipoTarjeta.issuer === "unknown") {
      mostrarModal(
        "Tipo de tarjeta inválida",
        "Debe ingresar un tipo de tarjeta válido."
      );
      return;
    }

    //Valores tarjeta
    const numeroTarjeta = tarjetaCredito.number.replace(/ /g, "");
    const tarjetaCvv = tarjetaCredito.cvv.replace("_", "").replace(" ", "");
    const fechaExpiracion = tarjetaCredito.expiry
      .replace("/", "")
      .replace("_", "");

    const tarjetaNumberLength = numeroTarjeta.length;
    const tarjetaCvcLength = tarjetaCvv.length;
    const isValidCardNumber = [15, 16].includes(tarjetaNumberLength);
    const isValidExpiryDate = fechaExpiracion.length === 4;
    let isValidCVV = false;
    if (tarjetaNumberLength === 15) {
      if (tarjetaCvcLength === 4) isValidCVV = true;
    } else if (tarjetaCvcLength === 3) isValidCVV = true;

    if (!isValidCVV) {
      mostrarModal(
        "Número CVC Invalido",
        "Debe ingresar un número CVV valido."
      );
      return;
    } else if (!isValidCardNumber) {
      mostrarModal(
        "Número de tarjeta Invalido",
        "El rango minio de longitud es de 16 digitos"
      );
      return;
    } else if (!isValidExpiryDate) {
      mostrarModal(
        "Fecha expiración Invalido",
        "Debe ingresar una fecha expiración valida."
      );
      return;
    }

    const mes = fechaExpiracion.substring(0, 2);
    const anio = fechaExpiracion.substring(2, fechaExpiracion.length);

    return {
      mesExpiracion: mes,
      // anoExpiracion: String(new Date().getFullYear())
      //   .substring(0, 2)
      //   .concat(anio),
      anoExpiracion: anio,
      cvv: tarjetaCredito.cvv,
      numeroTarjeta: numeroTarjeta,
    };
  };

  const onProcederPago = () => {
    //Validación de pago
    let montoTotal = 0;
    if (
      getPolicyType(datosFacturacion.data.poliza) === PRODUCT_TYPES.BUEN_VIAJE
    ) {
      montoTotal = balancePoliza.totalPagar;
    } else if (
      montoPagar === "pagoTotal" &&
      getPolicyType(datosFacturacion.data.poliza) !== PRODUCT_TYPES.BUEN_VIAJE
    ) {
      montoTotal = balancePoliza.totalPagar;
    } else if (
      montoPagar === "pagoMinimo" &&
      getPolicyType(datosFacturacion.data.poliza) !== PRODUCT_TYPES.BUEN_VIAJE
    ) {
      montoTotal = balancePoliza.pagoMinimo;
    } else if (
      montoPagar === "" &&
      getPolicyType(datosFacturacion.data.poliza) !== PRODUCT_TYPES.BUEN_VIAJE
    ) {
      mostrarModal(
        CONSTANT.ERROR_PAGO,
        "Debe seleccionar el tipo de monto a pagar. Mínimo o Total."
      );
      return;
    }

    // Proceso pago
    let requestPago = {
      usuario: CONSTANT.USUARIO_PAGO,
      idTransaccion: balancePoliza.numeroReferencia,
      montoPago: montoTotal,
      impuesto: 0,
      mesExpiracion: detalleTarjeta.mesExpiracion,
      anoExpiracion: detalleTarjeta.anoExpiracion,
      numeroTarjeta: detalleTarjeta.numeroTarjeta,
      numeroSeguridadTarjeta: detalleTarjeta.cvv,
    };

    if (!accessToken) {
      mostrarModal(
        CONSTANT.ERROR_PAGO,
        "No hay sesión de pago. Recargue la página e intente de nuevo."
      );
      return;
    }

    setIsLoadingModal(true);

    procesarYRegistrarPago(requestPago, accessToken).then(async (response) => {
      if (response.status === 200) {
        if (typeof response.data.RestError !== "undefined") {
          setIsLoadingModal(false);
          mostrarModal(
            CONSTANT.ERROR_PAGO,
            response.data.RestError?.errorMessage || CONSTANT.DECLINADA
          );
          return;
        }

        if (response.data.codigoRespuesta === 0) {
          try {
            const requestNotificar = {
              poliza: datosFacturacion?.data?.poliza,
              nombreAsegurado: datosFacturacion?.data?.contratante?.nombre,
              numeroAutorizacion: response?.data?.numeroAutorizacion,
              totalPagado: montoTotal,
            };

            notificarPagoIntermediario(requestNotificar);
          } catch (error) {}

          setIsLoadingModal(false);

          mostrarModal(
            "Confirmación de pago",
            "El pago fue procesado correctamente.",
            "success",
            response.data.numeroRecibo,
            response.data.numeroAutorizacion
          );
        } else {
          setIsLoadingModal(false);
          mostrarModal(CONSTANT.ERROR_PAGO, CONSTANT.DECLINADA);
          return;
        }
      } else {
        setIsLoadingModal(false);
        mostrarModal(
          CONSTANT.ERROR_PAGO,
          response.data?.RestError?.errorMessage || CONSTANT.DECLINADA
        );
      }
    });
  };

  const mostrarModalPago = (titulo, mensaje) => {
    const hideModal = () => {
      setModal({ isVisible: false, component: null });
    };

    const successModal = () => {
      setModal({ isVisible: false, component: null });
      onProcederPago();
    };

    setModal({
      isVisible: true,
      component: (
        <ModalPago
          cuerpo={mensaje}
          onCancel={hideModal}
          titulo={titulo}
          onSuccess={successModal}
        />
      ),
    });
  };

  const mostrarModalDomiciliacion = () => {
    const hideModal = () => {
      setModal({ isVisible: false, component: null });
      window.location.reload();
    };

    setModal({
      isVisible: true,
      component: <ModalDomiciliacion onCancel={hideModal} />,
    });
  };

  const onConfirmarPago = (event) => {
    event.preventDefault();
    const cardDetail = obtenerNumeroTarjeta(tarjeta);

    if (cardDetail === undefined) {
      return;
    }

    detalleTarjeta = cardDetail;

    let mensajeBalance = {};
    setIsLoadingModal(true);

    let montoTotal = 0;
    if (
      getPolicyType(datosFacturacion.data.poliza) === PRODUCT_TYPES.BUEN_VIAJE
    ) {
      montoTotal = balancePoliza.totalPagar;
    } else if (
      montoPagar === "pagoTotal" &&
      getPolicyType(datosFacturacion.data.poliza) !== PRODUCT_TYPES.BUEN_VIAJE
    ) {
      montoTotal = balancePoliza.totalPagar;
    } else if (
      montoPagar === "pagoMinimo" &&
      getPolicyType(datosFacturacion.data.poliza) !== PRODUCT_TYPES.BUEN_VIAJE
    ) {
      montoTotal = balancePoliza.pagoMinimo;
    }

    if (balancePoliza.codigoRespuesta === 0) {
      mensajeBalance = {
        encabezado: "",
        factura:
          getPolicyType(datosFacturacion.data.poliza) ===
          PRODUCT_TYPES.BUEN_VIAJE
            ? datosFacturacion.data.factura
            : null,
        monto: currencyFormater.format(montoTotal),
        validacion: "Para continuar, presione aceptar",
      };

      setIsLoadingModal(false);
      mostrarModalPago("Procesar Pago:", mensajeBalance);
    }
    setIsLoadingModal(false);
    return;
  };

  const callBackTarjeta = (e) => {
    setTipoTarjeta(e);
  };

  const onChangeSelect = (event) => {
    setMontoPagar(event.target.value);

    if (event.target.value === "") {
      setRenderButton(false);
    } else if (
      event.target.value === "pagoMinimo" ||
      event.target.value === "pagoTotal"
    ) {
      setRenderButton(true);
    }
  };

  return (
    <div className="flex flex-1  flex-col md:flex-row lg:flex-row mx-2">
      <div className="mb-2 border-solid border-gray-300 rounded border shadow-sm w-full">
        <div className="bg-primary text-white px-2 py-3 border-solid border-gray-200 border-b">
          Formulario Tarjeta
        </div>
        <div className="p-3">
          <form className="w-full">
            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0 mt-5">
                <Cards
                  cvc={tarjeta.cvv}
                  expiry={tarjeta.expiry}
                  focused={focus === "cvv" ? "cvc" : focus}
                  name={tarjeta.name}
                  number={tarjeta.number}
                  locale={{ valid: "Válido hasta" }}
                  callback={callBackTarjeta}
                />
              </div>
              <div className="w-full md:w-1/2 px-3">
                <label
                  className="block  tracking-wide text-gray-700 text-xs font-light mb-1"
                  htmlFor="grid-last-name"
                >
                  Nombre Tarjeta:
                </label>
                <Input
                  value={tarjeta.name}
                  type="text"
                  name="name"
                  className="appearance-none block w-full bg-grey-200 text-grey-darker border border-grey-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-grey text-sm"
                  onChange={onChange}
                  onFocus={onFocus}
                  onKeyPress={(event) => {
                    if (!/[a-zA-Z ]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                />
                <div className="flex flex-wrap -mx-3 mb-2 w-full">
                  <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                    <label
                      className="block  tracking-wide text-gray-700 text-xs font-light mb-1 mt-5"
                      htmlFor="grid-last-name"
                    >
                      Número Tarjeta:
                    </label>
                    <Input
                      value={tarjeta.number}
                      name="number"
                      className="appearance-none block w-full bg-grey-200 text-grey-darker border border-grey-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-grey text-sm"
                      onChange={onChange}
                      onFocus={onFocus}
                      maxLength={19}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </div>
                </div>
                <div className="flex flex-wrap -mx-3">
                  <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                    <label
                      className="block  tracking-wide text-grey-darker text-xs font-light mb-1"
                      htmlFor="grid-city"
                    >
                      Fecha Expiración:
                    </label>
                    <MaskInput
                      value={tarjeta.expiry}
                      alwaysShowMask={false}
                      maskChar="_"
                      mask="00/00"
                      size={4}
                      name="expiry"
                      placeholder="MM/YY"
                      className="appearance-none block w-full bg-grey-200 text-grey-darker border border-grey-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-grey text-sm"
                      onChange={onChange}
                      onFocus={onFocus}
                      maxLength={4}
                      onKeyPress={(event) => {
                        if (!/[1-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </div>
                  <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                    <label
                      className="block  tracking-wide text-grey-darker text-xs font-light mb-1"
                      htmlFor="grid-zip"
                    >
                      CVC:
                    </label>
                    <MaskInput
                      value={tarjeta.cvv}
                      alwaysShowMask={false}
                      maskChar=""
                      mask="0000"
                      size={3}
                      name="cvv"
                      placeholder="CVC"
                      className="appearance-none block w-full bg-grey-200 text-grey-darker border border-grey-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-grey text-sm"
                      onChange={onChange}
                      onFocus={onFocus}
                      maxLength={3}
                      onKeyPress={(event) => {
                        if (!/[1-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </div>
                </div>
                {getPolicyType(datosFacturacion.data.poliza) !==
                  PRODUCT_TYPES.BUEN_VIAJE && (
                  <div className="flex flex-wrap -mx-3 mb-2 w-full">
                    <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                      <label
                        className="block  tracking-wide text-gray-700 text-xs font-light mb-1 mt-5"
                        htmlFor="grid-last-name"
                      >
                        Monto a pagar:
                      </label>
                      <Select
                        onChangeSelect={onChangeSelect}
                        className="appearance-none block  bg-grey-200 text-grey-darker border border-grey-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-grey text-sm"
                        defaultSelectValue="Seleccione el monto a pagar"
                        data={
                          balancePoliza.pagoMinimo === 0
                            ? selectMontoPago.filter(
                                (c) => c.value !== "pagoMinimo"
                              )
                            : selectMontoPago
                        }
                      />
                    </div>
                  </div>
                )}
                <div className="flex flex-wrap -mx-3 mb-2 mt-5">
                  <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                    {getPolicyType(datosFacturacion.data.poliza) !==
                      PRODUCT_TYPES.BUEN_VIAJE && (
                      <Button
                        className={`btn btn-primary btn-sm btn-success ${
                          !renderButton ? "opacity-50 cursor-not-allowed" : ""
                        }`}
                        onClick={onConfirmarPago}
                        disabled={!renderButton}
                      >
                        Realizar Pago
                      </Button>
                    )}
                    {getPolicyType(datosFacturacion.data.poliza) ===
                      PRODUCT_TYPES.BUEN_VIAJE && (
                      <Button
                        className={`btn btn-primary btn-sm btn-success`}
                        onClick={onConfirmarPago}
                      >
                        Realizar Pago
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default FormTarjeta;
